var React = require('react');

function IconCaretDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.468 10l.803-.687 8.665-7.427L17.331 0 9.468 6.741 1.605 0 0 1.886l8.665 7.427.803.687z"}));
}

IconCaretDown.defaultProps = {"width":"19","height":"10"};

module.exports = IconCaretDown;

IconCaretDown.default = IconCaretDown;
